import React, { Component } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import like from '../../assets/img/people/like.svg'
import beforelike from '../../assets/img/people/beforelike.svg'
import chat from '../../assets/img/people/chat.svg'
import axios from 'axios';
import Lottie from "lottie-react";
import noitems from '../../assets/json/noitems.json'
import { Redirect } from 'react-router-dom';
import { Trans } from "react-i18next";   
import "../../config/i18n";
import { withTranslation } from "react-i18next";

class Feeds extends Component {
    constructor(props) {
        super(props); 
        this.state = {
            peopleDetails: [],
            feedsAvailability: 0,
            items: [],
            api_url:localStorage.getItem('api_url'),
            likedFeeds: {}, 
        } 
    }

    componentDidMount() {
        if (this.props.i18n.language === 'ar' || this.props.i18n.language === 'he') {
            document.body.dir = 'rtl';
            document.body.classList.add('rtl');
            document.body.classList.remove('ltr')
        } else {
            document.body.dir = 'ltr';
            document.body.classList.remove('rtl');
            document.body.classList.add('ltr');
        }
         
        const apiUrl = localStorage.getItem('api_url');
        var profile = new FormData();
        profile.set('user_id',JSON.parse(localStorage.getItem('session_userid')));
        profile.set('language', this.state.langKey);  
        axios({
            method: 'post',
            url: apiUrl+'webfeeds',
            data: profile,
            config: { headers: {'Content-Type': 'multipart/form-data' }}
        }).then(res => {
            const data = res.data;
            if(data.status === "true") {
                this.setState({
                    feedsAvailability: 1, 
                    peopleDetails: data.feeds, 
                });
            } 
        })
    }

    feedLike(FeedId) {
        this.setState(prevState => ({
            likedFeeds: {
                ...prevState.likedFeeds,
                [FeedId]: true,
            }
        }));
        
        var report = new FormData();
        report.append('user_id',JSON.parse(localStorage.getItem('session_userid')));
        report.append('feed_id',FeedId); 
        report.append('language', this.state.langKey);  
        axios({
            method: 'post',
            url: this.state.api_url+'webfeedlike', 
            data: report,
            config: { headers: {'Content-Type': 'multipart/form-data' }}
        }).then(res => {
            if(res.data.status === "true") {
                  
            } else {
                this.setState(prevState => ({
                    likedFeeds: {
                        ...prevState.likedFeeds,
                        [FeedId]: false,
                    }
                }));
            }
        }).catch(() => {
            this.setState(prevState => ({
                likedFeeds: {
                    ...prevState.likedFeeds,
                    [FeedId]: false,
                }
            }));
        });
    }  

    Message(receiverId) { 
        const apiUrl = localStorage.getItem('api_url');
        var report = new FormData();
        report.append('sender_id',JSON.parse(localStorage.getItem('session_userid')));
        report.append('receiver_id',receiverId);
        report.append('language', receiverId); 
        axios({
            method: 'post',
            url: apiUrl+'webcreatchat',
            data: report,
            config: { headers: {'Content-Type': 'multipart/form-data' }}
        }).then(res => {
            this.setState({ MessageNew: true , receiverId: receiverId, chatid: res.data.chatid});
        })
    }

    render() {
        if (this.state.MessageNew) {
            const url = `/message/${this.state.receiverId}/${this.state.chatid}`;
            return <Redirect to={url} />;
        }
        const { t } = this.props;

        return (
            <div className="common_layout">
                <div className='header_layout'>
                    <div className='header_title margin_auto'>
                        <h4><Trans i18nKey="Feeds">Feeds</Trans></h4>
                    </div>
                </div>
                <div className='mt_2'>
                    <Container>
                        <Row>
                            <Col md={8} className='margin_auto'>
                                {(this.state.feedsAvailability === 1) ?
                                    this.state.peopleDetails.map(peopleDetails =>
                                        <div className='feeds_card'>
                                            <div className='feed_header'>
                                                <div className='feed_subheader'>
                                                    <div className='feed_avatar'>
                                                        <img src={peopleDetails.user_image} alt="img" />
                                                    </div>
                                                    <div>
                                                        <h4>{peopleDetails.user_name}</h4>
                                                        <p>{ (peopleDetails.feed_type === "image") ? t("Added new photo") : ((peopleDetails.feed_type === "location") ? t("Updated location") : t("Profile information changed"))}</p>
                                                    </div>
                                                </div>
                                                <p className='feed_days'>{peopleDetails.feed_time}</p>
                                            </div>
                                            <div className='feed_img'>
                                                {(peopleDetails.feed_type === "image") ?
                                                    <img src={peopleDetails.feed_content} alt="" />
                                                :
                                                    <img src={peopleDetails.user_image} alt="" />
                                                } 
                                            </div>
                                            <div className='feeds_bottom'>
                                                <div>
                                                    {peopleDetails.feed_type !== "image" && (
                                                        <h4>
                                                            {t(peopleDetails.feed_type)}
                                                            <br />
                                                            <span>
                                                                {peopleDetails.feed_content}
                                                            </span>
                                                        </h4>
                                                    )}
                                                </div>
                                                <div className='feeds_bottom_img'>
                                                    {
                                                        (this.state.likedFeeds[peopleDetails.feed_id] || peopleDetails.liked === "true") 
                                                        ?
                                                        <img src={like} className="active" alt="img" />
                                                        :
                                                        <img src={beforelike} alt="img" onClick={() => this.feedLike(peopleDetails.feed_id)} />
                                                    }
                                                    <img src={chat} alt="img" onClick={this.Message.bind(this, peopleDetails.user_id)}/>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                :
                                    <div className='superlike_lottie'>
                                        <div className='superlike_lottie_height'>
                                            <Lottie animationData={noitems} className='superlike_lottie_player' />
                                        </div>
                                        <div className='common_para mt_1'>
                                            <p>No Feeds</p>
                                        </div>
                                    </div>
                                }
                            </Col>
                        </Row>
                    </Container>
                </div>
            </div >
        );
    }
}

export default withTranslation("translations")(Feeds);
